import { AdminRoute } from "lego-gui-lib/lib";
import { NetworkOperator } from "./networkOperator/views";
import { Property } from "./property/views";
import { Dashboard } from "./remoteViews/dashboard/view";
import { Customers } from "./customer/views";
import { SANs } from "./san/views";
import { Messages } from "./message/views";
import { List } from "./list/views";
import { LanguageSelection } from "./languageSelection/views";
import { Languages } from "./language/views";
import { ServiceProfiles } from "./serviceProfile/views";
import { SanMatchings } from "./sanMatching/views";
import { BarringMatrixes } from "./barringMatrix/views";
import { Calendar } from "./calendar/views";
import { Areas } from "./area/views";
import { AreaSplittings } from "./areaSplitting/views";
import { ReportDefinitions } from "./reportDefinition/views";
import { WebUsers } from "./webUser/views";
import { WebUserRoleMapping } from "./webUserRoleMapping/views";
import { WebUserRoles } from "./webUserRole/views";

export const routes: AdminRoute[] = [
  Property,
  Customers,
  Dashboard,
  List,
  Calendar,
  LanguageSelection,
  Messages,
  NetworkOperator,
  Languages,
  SANs,
  ServiceProfiles,
  SanMatchings,
  BarringMatrixes,
  Areas,
  AreaSplittings,
  ReportDefinitions,
  WebUsers,
  WebUserRoles,
  WebUserRoleMapping
];
